<template>
  <div :class="['fav', { dark, border, active: isFavourite }]" @click="toggle">
    <img :src="image" alt="Mark as favourite" />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useStores } from "@/store/use.store";
import i18n from "@/i18n";

const props = defineProps({
  data: {
    type: Object,
    default: null,
  },
  dark: {
    type: Boolean,
    default: false,
  },
  border: {
    type: Boolean,
    default: false,
  },
  currentCourseRoute: {
    type: Boolean,
    default: false,
  },
});

const { favouriteCoursesStore, productsStore, auth2Store, alertStore } =
  useStores();

const { favouriteCourses } = storeToRefs(favouriteCoursesStore);
const { current } = storeToRefs(productsStore);

const courseShortName = computed(() =>
  props.currentCourseRoute
    ? current.value.shortName
    : props.data.id?.toString(),
);
const favouriteCourseEntry = computed(() =>
  favouriteCourses.value.find(
    (course) => course.course === courseShortName.value,
  ),
);
const isFavourite = computed(() => !!favouriteCourseEntry.value);
const image = computed(() => {
  if (props.dark) {
    return isFavourite.value
      ? require("../../assets/course/fav_dark_filled.svg")
      : require("../../assets/course/fav_dark.svg");
  }

  return isFavourite.value
    ? require("../../assets/course/fav_white_filled.svg")
    : require("../../assets/course/fav_white.svg");
});

const toggle = () => {
  if (!props.data) {
    return;
  }

  if (!auth2Store.isLoggedIn) {
    alertStore.warning(
      i18n.global.t("common.error"),
      i18n.global.t("common.not_logged_in"),
    );
    return;
  }

  if (!isFavourite.value) {
    favouriteCoursesStore.store(courseShortName.value);
    return;
  }

  if (!favouriteCourseEntry.value) {
    return;
  }
  favouriteCoursesStore.destroy(favouriteCourseEntry.value.id);
};
</script>

<style scoped lang="scss">
.fav {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 52px;
  height: 52px;
  border-radius: 8px;
  cursor: pointer;

  &.border.dark {
    border: 2px solid $color-primary;
  }

  &.border {
    border: 2px solid #fff;
  }
}
</style>
